import { render, staticRenderFns } from "./score-count.vue?vue&type=template&id=4d0c6316&scoped=true"
import script from "./score-count.vue?vue&type=script&lang=js"
export * from "./score-count.vue?vue&type=script&lang=js"
import style0 from "./score-count.vue?vue&type=style&index=0&id=4d0c6316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c6316",
  null
  
)

export default component.exports